import {
  PaletteIcon,
  Settings2Icon,
  SparklesIcon,
  UsersIcon,
} from "lucide-react";

import { Button } from "@/components/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
} from "@/components/dialog";
import { Modal } from "@/components/modal";

interface UnlockModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onUpgrade?: () => void;
}

const features = [
  {
    icon: <PaletteIcon className="text-fg-brand-primary" size={24} />,
    title: "Choose your design capabilities",
  },
  {
    icon: <Settings2Icon className="text-fg-brand-primary" size={24} />,
    title: "Decide the design volume",
  },
  {
    icon: <UsersIcon className="text-fg-brand-primary" size={24} />,
    title: "Experience a seamless and scalable design partnership.",
  },
];

export function UnlockModal({
  isOpen,
  onOpenChange,
  onUpgrade,
}: UnlockModalProps) {
  const handleUpgrade = () => {
    onUpgrade?.();
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Modal
      classNames={{ modal: "w-[400px]", modalOverlay: "!z-[70]" }}
      isDismissable
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog>
        <DialogBody className="p-6">
          <DialogCloseButton />

          {/* Header with icon */}
          <div className="flex flex-col gap-xl mb-6">
            <div className="size-12 shrink-0 grid place-items-center rounded-full bg-bg-brand-secondary">
              <SparklesIcon className="text-fg-brand-primary" size={24} />
            </div>

            <div className="flex flex-col gap-xs">
              <h2 className="text-lg font-semibold text-text-primary">
                Unlock premium features
              </h2>
              <p className="text-sm text-text-tertiary">
                The kickstarter plan has limited access to user functionality.
                Upgrade to unlock full potential of our platform and design
                services.
              </p>
            </div>
          </div>

          {/* Features list */}
          <div className="flex flex-col gap-sm mb-6">
            {features.map((feature, index) => (
              <div
                className="flex items-center gap-3 p-[16px] rounded-lg border border-border-secondary"
                key={index}
              >
                <div className="size-10 shrink-0 grid place-items-center rounded-lg bg-bg-brand-secondary">
                  {feature.icon}
                </div>
                <span className="text-sm font-medium text-text-primary">
                  {feature.title}
                </span>
              </div>
            ))}
          </div>
        </DialogBody>

        <DialogFooter className="px-6 pb-6 pt-0">
          <div className="flex flex-col gap-sm w-full">
            <Button
              className="w-full"
              onPress={handleUpgrade}
              size="lg"
              variant="primary"
            >
              Upgrade now
            </Button>

            <Button
              className="w-full"
              color="gray"
              onPress={handleClose}
              size="lg"
              variant="secondary"
            >
              Continue with free plan
            </Button>
          </div>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
